<template>
  <div class="my-auto text-white">
    <div class="text-center">
      <h3 class="mt-0 text-info">{{ title }}</h3>
      <p class="text-white mb-4">{{ message }}</p>
    </div>

    <div v-if="success" class="logout-icon m-auto">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px" y="0px" viewBox="0 0 161.2 161.2" enable-background="new 0 0 161.2 161.2" xml:space="preserve">
        <path class="path" fill="none" stroke="#0acf97" stroke-miterlimit="10" d="M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4 c-2.3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5 c0.3-0.3,0.5-0.6,0.7-0.9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z" />
        <circle class="path" fill="none" stroke="#0acf97" stroke-width="4" stroke-miterlimit="10" cx="80.6" cy="80.6" r="62.1" />
        <polyline class="path" fill="none" stroke="#0acf97" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="113,52.8 74.1,108.4 48.2,86.4 " />
        <circle class="spinner" fill="none" stroke="#0acf97" stroke-width="4" stroke-miterlimit="10" stroke-dasharray="12.2175,12.2175" cx="80.6" cy="80.6" r="73.9" />
      </svg>
    </div>
    <div v-if="!success" class="logout-icon m-auto">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px" y="0px" viewBox="0 0 161.2 161.2" xml:space="preserve">
        <circle class="path" fill="none" stroke="#e3342f" stroke-width="4" stroke-miterlimit="10" cx="80.6" cy="80.6" r="62.1" />
        <line class="path" fill="none" stroke="#e3342f" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="55" y1="55" x2="106" y2="106" />
        <line class="path" fill="none" stroke="#e3342f" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="106" y1="55" x2="55" y2="106" />
        <circle class="spinner" fill="none" stroke="#e3342f" stroke-width="4" stroke-miterlimit="10" stroke-dasharray="12.2175,12.2175" cx="80.6" cy="80.6" r="73.9" />
      </svg>
    </div>
  </div>

  <!-- Footer -->
  <footer class="footer footer-alt">
    <p class="text-white">
      {{ $t('logout.backTo') }}
      <router-link to="/login" class="text-info ms-1" @click="cancelRedirect">
        <b>{{ $t('common.backToLogin') }}</b>
      </router-link>
    </p>
  </footer>
</template>

<script>
import { useUserStore } from '@/stores/userStore';
import { onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';

export default {
  name: "ResultPage",
  setup() {
    const userStore = useUserStore();
    const router = useRouter();
    const route = useRoute();
    const success = ref(route.query.success === 'true');
    const title = ref(route.query.title);
    const message = ref(route.query.message);
    let timeoutId = ref(null);


    const logoutAndRedirect = async () => {
      await userStore.logout();
      timeoutId.value = setTimeout(() => {
        router.push({ path: '/login' });
      }, 5000);
    };

    const cancelRedirect = () => {
      if (timeoutId.value) {
        clearTimeout(timeoutId.value);
      }
    };

    onMounted(() => {
      logoutAndRedirect();
    });

    return {
      cancelRedirect,
      success,
      title,
      message,
    };
  },
};
</script>

<style scoped>
.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 2s ease-out forwards;
}

.spinner {
  transform-origin: center;
  animation: spin 4s linear infinite;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>